
export class PDFStyles {

    public static get appl() { return appl }

}

const appl = {
    covertext: {
        alignment: "center",
        fontSize: 11.5
    },
    pagetext: {
        alignment: "left",
        fontSize: 11.5
    },
    header1: {
        fontSize: 18,
        bold: true
    },
    header2: {
        fontSize: 16,
        bold: true,
        color: '#19719e',
        italic: true,
        margin: [0, 10]
    },
    header3: {
        fontSize: 12,
        bold: true,
        color: '#19719e',
        margin: [0, 10],
        alignment: "justify",
    },
    header4: {
        fontSize: 12,
        color: '#19719e',
        margin: [10, 5]
    },
    coverHeader: {
        fontSize: 13,
        bold: true,
        italic: true,
    },
    coverTitle: {
        fontSize: 12,
        color: '#19719e',
        margin: [10, 5],
        italic: true,
    },
    tblheader: {
        fontSize: 12,
        bold: true,
        fillColor: "#d5d6d4",
        alignment: "justify"
    },
    tbltitle: {
        fontSize: 10
        
    },
    tblcell: {
        fontSize: 10
    },
    colheader: {
        fontSize: 8,
        bold: true,
        alignment: "center"
    },
    coltext: {
        fontSize: 8,
        alignment: "left",
        margin: 5
    },
    freqheader: {
        fontSize: 8, 
        fillColor: '#d5d6d4', 
        bold: true
    },
    variablelink: {
        fontSize: 8,
        alignment: "left",
        decoration: 'underline',
        color: 'blue'
    },
    formQn: {
        fontSize: 8,
        alignment: "left",
        margin: 5
    },
    formAns: {
        fontSize: 10,
        alignment: "left",
        margin: 5
    }

}